import { API } from 'aws-amplify';

export default {
  updateProfile(mpID, { firstName, lastName, phoneNumber }) {
    const query = `mutation updateProfile($mpID: String!, $firstName: String, $lastName: String, $phoneNumber: String) {
      updateProfile(
        mpID: $mpID
        firstName: $firstName
        lastName: $lastName
        phoneNumber: $phoneNumber
      ) {
        mpID
        firstName
        lastName
        email
        phoneNumber
      }
    }`;

    return API.graphql({
      query,
      variables: {
        mpID,
        firstName,
        lastName,
        phoneNumber,
      },
    })
  },

  getProfile(mpID) {
    const query = `query getProfile($mpID: String!) {
      getProfile(
        mpID: $mpID
      ) {
        mpID
        firstName
        lastName
        email
        phoneNumber
        avatar
      }
    }`;

    return API.graphql({
      query,
      variables: {
        mpID,
      },
    })
  },

  updateUserAvatar(mpID, avatar) {
    const query = `mutation updateProfile($mpID: String!, $avatar: String) {
      updateProfile(
        mpID: $mpID
        avatar: $avatar
      ) {
        mpID
      }
    }`;

    return API.graphql({
      query,
      variables: {
        mpID,
        avatar,
      },
    })
  },
};
